(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (
    typeof customElements !== 'undefined' &&
    typeof MutationObserver !== 'undefined' &&
    !customElements.get('inkforge-route-cart-default')
  ) {
    customElements.define('inkforge-route-cart-default', class extends HTMLElement {
      connectedCallback() {
        this.handled = new WeakSet();
        this.userInteracted = false;
        this.stopped = false;
        this.frame = null;
        this.toggleSelector = 'button[type="button"][id^="route-widget-preferred-checkout-accordion-header-icon-"][aria-controls="protection-benefits"][aria-expanded]';
        this.onInteraction = (event) => {
          if (
            event.isTrusted &&
            event.target instanceof Element &&
            event.target.closest('.cart-page__summary .pw-accordion-benefits-container')
          ) {
            this.userInteracted = true;
          }
        };
        this.schedule = () => {
          if (this.stopped || this.frame !== null || this.userInteracted) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.expand();
          });
        };
        try {
          this.observer = new MutationObserver(this.schedule);
          this.observer.observe(this, { childList: true, subtree: true });
          this.addEventListener('click', this.onInteraction, true);
          this.schedule();
        } catch {
          this.stop();
        }
      }

      expand() {
        try {
          if (!this.isConnected || this.userInteracted || this.stopped) return;
          for (const summary of this.querySelectorAll('.cart-page__summary')) {
            if (summary.closest('theme-drawer, cart-drawer-component, dialog')) continue;
            for (const button of summary.querySelectorAll(this.toggleSelector)) {
              if (
                !(button instanceof HTMLButtonElement) ||
                button.disabled ||
                !button.closest('.pw-variant-preferred-checkout .pw-accordion-benefits-container') ||
                this.handled.has(button)
              ) continue;
              this.handled.add(button);
              if (button.getAttribute('aria-expanded') === 'false') button.click();
            }
          }
        } catch {
          this.stop();
        }
      }

      stop() {
        this.stopped = true;
        this.observer?.disconnect();
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.frame = null;
        if (this.onInteraction) this.removeEventListener('click', this.onInteraction, true);
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inkforge-product-carousel')) {
    customElements.define('inkforge-product-carousel', class extends HTMLElement {
      connectedCallback() {
        this.update = () => {
          const track = this.querySelector('.inkforge-recs-track');
          const arrows = this.querySelector('.inkforge-car-arrows');
          if (track && arrows) arrows.hidden = track.scrollWidth <= track.clientWidth + 4;
        };
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this);
        this.mutationObserver = new MutationObserver(this.update);
        this.mutationObserver.observe(this, { childList: true, subtree: true });
        this.update();
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
